import React, { forwardRef } from "react"
import { Avatar, Group, Text } from "@mantine/core"
import { API_URL } from "../../../shared/config"
import { type Instructor } from "../../../shared/types/instructor"

type ItemProps = React.ComponentPropsWithoutRef<"div"> & Instructor & {
  value: string
  label: string
}

export const SelectorElement = forwardRef<HTMLDivElement, ItemProps>(
  function SelectorElement(
    {
      avatar,
      name,
      position,
      published,
      createdAt,
      _id,
      updatedAt,
      socials,
      ...others
    }: ItemProps, ref) {
    return (
      <div ref={ref} {...others}>
        <Group noWrap>
          <Avatar src={`${API_URL}/media/${avatar}`}/>

          <div>
            <Text size="sm">{name}</Text>
            <Text maw={500} truncate={true} size="xs" opacity={0.65}>
              {position}
            </Text>
          </div>
        </Group>
      </div>
    )
  },
)
